import { setIsAdminEmbed } from '@/lib/store/theme/actions';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

export function useValidateAdminEmbed() {
  const dispatch = useDispatch();
  const adminUrl = process.env.NEXT_PUBLIC_ADMIN_URL;

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    // Safe check if we're in an iframe
    const isIframe = window.self !== window.top;

    if (isIframe && adminUrl) {
      // Setup message listener for parent communication
      const messageHandler = (event: MessageEvent) => {
        // Verify the message is from our admin domain
        if (event.origin === new URL(adminUrl).origin) {
          if (event.data === 'admin-embed-verification') {
            dispatch(setIsAdminEmbed(true));
          }
        }
      };

      window.addEventListener('message', messageHandler);

      // Return cleanup function
      return () => {
        window.removeEventListener('message', messageHandler);
      };
    }
  }, [adminUrl]);
}
